if (!customElements.get('slider-text-carousel')) {
  class SliderText extends HTMLElement {

    constructor() {
      super();
      this.initSlider();
    }

    initSlider() {
      const options = {
        container: this.querySelector('[data-slider]'),
        prevButton: this.querySelector('[data-slider-prev]'),
        nextButton: this.querySelector('[data-slider-next]'),
        disable: true,
        controls: false,
        responsive: {
          768: {
            disable: false,
            nav: false,
            preventScrollOnTouch: 'auto',
            controls: true,
            loop: true,
            nav: false,
            items: 2,
            gutter: 12
          },
          1280: {
            items: 3
          }
        }
      };
      tns(options);
    }
  }
  customElements.define('slider-text-carousel', SliderText);
}